<template>
  <div class="hotspot"></div>
</template>

<script>
  export default {
    name: 'Hotspot'
  }
</script>

<style scoped>
  .hotspot {
    cursor: pointer;
    position: absolute;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    box-shadow: 0 0 0 0 rgba(90, 153, 212, .5);
    animation: pulse 2s infinite;
  }
  .hotspot:hover {
    animation: none;
  }
  @keyframes pulse {
    70% {
      box-shadow: 0 0 10px 10px rgba(90, 153, 212, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(90, 153, 212, 0);
    }
  }
  .activate {
    width: 34px;
    height: 34px;
  }
  .mobile-hotspot {
    top: 26%;
    left: 3.4%;
  }
  .iot-hotspot {
    top: 41%;
    left: 0.6%;
  }
  .tracking-hotspot {
    top: 57.5%;
    left: 3.5%;
  }
  .any-format-hotspot {
    top: 72.7%;
    left: 0.6%;
  }
  .sensitize-hotspot {
    top: 27.4%;
    left: 33.8%;
  }
  .scheme-hotspot {
    top: 83.9%;
    left: 26.1%;
  }
  .data-lake-hotspot {
    width: 52px;
    height: 52px;
    top: 74%;
    left: 47%;
  }
  .enrich-hotspot {
    top: 17.3%;
    left: 47.8%;
  }
  .consumer-hotspot {
    top: 78.1%;
    left: 55.4%;
  }
  .api-hotspot {
    top: 21.3%;
    left: 64.7%;
  }
  .optimization-hotspot {
    top: 41.5%;
    left: 74%;
  }
  .marketing-hotspot {
    top: 48%;
    left: 66.6%;
  }
  .reporting-hotspot {
    top: 55.5%;
    left: 71%;
  }
  .campaign-hotspot {
    top: 48.9%;
    left: 79.7%;
  }
  .decentralization-hotspot {
    top: 55.5%;
    left: 84.7%;
  }
  @media (max-width: 1199px) {
    .hotspot {
      width: 18px;
      height: 18px;
    }
    .activate {
      width: 27px;
      height: 27px;
    }
    .mobile-hotspot {
      top: 27.4%;
      left: 2.6%;
    }
    .iot-hotspot {
      top: 42%;
      left: -0.2%;
    }
    .tracking-hotspot {
      top: 57.6%;
      left: 2.6%;
    }
    .any-format-hotspot {
      top: 72.6%;
      left: -0.2%;
    }
    .sensitize-hotspot {
      top: 28.6%;
      left: 32.5%;
    }
    .scheme-hotspot {
      top: 83.5%;
      left: 24.8%;
    }
    .data-lake-hotspot {
      width: 40px;
      height: 40px;
      top: 74%;
      left: 45.5%;
    }
    .enrich-hotspot {
      top: 18.6%;
      left: 46.2%;
    }
    .consumer-hotspot {
      top: 78%;
      left: 53.8%;
    }
    .api-hotspot {
      top: 22.6%;
      left: 62.8%;
    }
    .optimization-hotspot {
      top: 42.2%;
      left: 72%;
    }
    .marketing-hotspot {
      top: 48.5%;
      left: 64.8%;
    }
    .reporting-hotspot {
      top: 56%;
      left: 69.1%;
    }
    .campaign-hotspot {
      top: 49.5%;
      left: 77.7%;
    }
    .decentralization-hotspot {
      top: 56%;
      left: 82.6%;
    }
  }
  @media (max-width: 991px) {
    .hotspot {
      width: 40px;
      height: 40px;
    }
    .activate {
      width: 60px;
      height: 60px;
    }
    .mobile-hotspot,
    .iot-hotspot,
    .tracking-hotspot,
    .any-format-hotspot,
    .scheme-hotspot {
      display: none;
    }
    .sensitize-hotspot {
      top: 30.8%;
      left: 72.2%;
    }
    .data-lake-hotspot {
      width: 65px;
      height: 65px;
      top: 43%;
      left: 80.5%;
    }
    .enrich-hotspot {
      top: 49.3%;
      left: 9.5%;
    }
    .consumer-hotspot {
      top: 47%;
      left: 68%;
    }
    .api-hotspot {
      top: 64.8%;
      left: 85%;
    }
    .optimization-hotspot {
      top: 70%;
      left: 54.5%;
    }
    .marketing-hotspot {
      top: 60%;
      left: 44.3%;
    }
    .reporting-hotspot {
      top: 65%;
      left: 32.5%;
    }
    .campaign-hotspot {
      top: 75.3%;
      left: 42.5%;
    }
    .decentralization-hotspot {
      top: 83%;
      left: 32%;
    }
  }
  @media (max-width: 575px) {
    .hotspot {
      width: 26px;
      height: 26px;
    }
    .activate {
      width: 40px;
      height: 40px;
    }
    .mobile-hotspot,
    .iot-hotspot,
    .tracking-hotspot,
    .any-format-hotspot,
    .scheme-hotspot {
      display: none;
    }
    .sensitize-hotspot {
      top: 31.7%;
      left: 72%;
    }
    .data-lake-hotspot {
      width: 40px;
      height: 40px;
      top: 43.5%;
      left: 80%;
    }
    .enrich-hotspot {
      top: 49.5%;
      left: 8.8%;
    }
    .consumer-hotspot {
      top: 47.4%;
      left: 67.5%;
    }
    .api-hotspot {
      top: 64.5%;
      left: 84.6%;
    }
    .optimization-hotspot {
      top: 69.6%;
      left: 53.9%;
    }
    .marketing-hotspot {
      top: 59.7%;
      left: 43.3%;
    }
    .reporting-hotspot {
      top: 64.5%;
      left: 31.6%;
    }
    .campaign-hotspot {
      top: 74.5%;
      left: 42%;
    }
    .decentralization-hotspot {
      top: 82%;
      left: 31.1%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Features/Hotspot.vue